import React from 'react';
import styles from '../../css/TravelFeatures.module.css';
import image from '../../assets/images/image_6.png';
import image1 from '../../assets/images/image_7.png';
import image2 from '../../assets/images/image_8.png';

function TravelFeatures() {
	return (
		<section className={styles.section}>
			<h2 className={styles.heading}>
				A smart and scalable corporate travel management solution
			</h2>

			<div className={styles.grid}>
				{/* Feature 1 */}
				<div className={styles.card}>
					<div className={styles.textBlock}>
						<h3>Policy control without complexity</h3>
						<p>
							Set it and forget it. Exporest’s policy management is simple,
							granular, and dynamic. Create flexible policies by role, trip
							type, or cost center. Prevent overspending without manual
							oversight.
						</p>
					</div>
					<div className={styles.imageBlock}>
						<img src={image} alt="Flight policy configuration" />
					</div>
				</div>

				{/* Feature 2 */}
				<div className={styles.card}>
					<div className={styles.textBlock}>
						<h3>Approval workflows that fit your business</h3>
						<p>
							Decide which bookings need review and who approves them. Route
							requests by team, travel type, or spend limits for streamlined
							approvals.
						</p>
					</div>
					<div className={styles.imageBlock}>
						<img src={image1} alt="Approval workflow sample" />
					</div>
				</div>

				{/* Feature 3 */}
				<div className={styles.card}>
					<div className={styles.textBlock}>
						<h3>Automate employee management</h3>
						<p>
							No more manual updates. Connect your HR system to sync employee
							data and travel policies in real time.
						</p>
					</div>
					<div className={styles.imageBlock}>
						<img src={image2} alt="HRIS integration illustration" />
					</div>
				</div>
			</div>
		</section>
	);
}

export default TravelFeatures;
